import { CommonEnums } from '../../common.enums';

export class KafkaProducerJob_Inst {

    kafkaproducer_inst_id: number;
    nm: string;
    description: string;
    ver: string;
    valid_Cd: string;
    dxFlow_Id: number;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    disableFlg: string;
    retryEnabled: string;
    numOfRetryAttempts: number;
    retryWaitTime: number;
    
    src_ConnNm: string;    //Read-Only
    tgt_ConnNm: string;    //Read-Only

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.kafkaproducer_inst_id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.ver = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.dxFlow_Id = CommonEnums.defaults.LONG_VAL;
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.disableFlg = CommonEnums.defaults.STRING_VAL_NO;
        this.retryEnabled = CommonEnums.defaults.STRING_EMPTY;
        this.numOfRetryAttempts = CommonEnums.defaults.NUM_VAL;
        this.retryWaitTime = CommonEnums.defaults.NUM_VAL;
        this.src_ConnNm = CommonEnums.defaults.STRING_EMPTY;
        this.tgt_ConnNm = CommonEnums.defaults.STRING_EMPTY;
    }

    copy(): KafkaProducerJob_Inst {

        let kafkaProducerJob_InstTmp: KafkaProducerJob_Inst = new KafkaProducerJob_Inst();

        kafkaProducerJob_InstTmp.kafkaproducer_inst_id = this.kafkaproducer_inst_id;
        kafkaProducerJob_InstTmp.nm = this.nm;
        kafkaProducerJob_InstTmp.description = this.description;
        kafkaProducerJob_InstTmp.ver = this.ver;
        kafkaProducerJob_InstTmp.valid_Cd = this.valid_Cd;
        kafkaProducerJob_InstTmp.dxFlow_Id = this.dxFlow_Id;
        kafkaProducerJob_InstTmp.updateBy = this.updateBy;
        kafkaProducerJob_InstTmp.lastUpdateBy = this.lastUpdateBy;
        kafkaProducerJob_InstTmp.updateDt = this.updateDt;
        kafkaProducerJob_InstTmp.disableFlg = this.disableFlg;
        kafkaProducerJob_InstTmp.retryEnabled = this.retryEnabled;
        kafkaProducerJob_InstTmp.numOfRetryAttempts = this.numOfRetryAttempts;
        kafkaProducerJob_InstTmp.retryWaitTime = this.retryWaitTime;
        kafkaProducerJob_InstTmp.src_ConnNm = this.src_ConnNm;
        kafkaProducerJob_InstTmp.tgt_ConnNm = this.tgt_ConnNm;

        return kafkaProducerJob_InstTmp;
    }

    copyFrom(kafkaProducerJob_InstTmp: KafkaProducerJob_Inst): void {
        this.kafkaproducer_inst_id = kafkaProducerJob_InstTmp.kafkaproducer_inst_id;
        this.nm = kafkaProducerJob_InstTmp.nm;
        this.description = kafkaProducerJob_InstTmp.description;
        this.ver = kafkaProducerJob_InstTmp.ver;
        this.valid_Cd = kafkaProducerJob_InstTmp.valid_Cd;
        this.dxFlow_Id = kafkaProducerJob_InstTmp.dxFlow_Id;
        this.updateBy = kafkaProducerJob_InstTmp.updateBy;
        this.lastUpdateBy = kafkaProducerJob_InstTmp.lastUpdateBy;
        this.updateDt = kafkaProducerJob_InstTmp.updateDt;
        this.disableFlg = kafkaProducerJob_InstTmp.disableFlg;
        this.retryEnabled = kafkaProducerJob_InstTmp.retryEnabled;
        this.numOfRetryAttempts = kafkaProducerJob_InstTmp.numOfRetryAttempts;
        this.retryWaitTime = kafkaProducerJob_InstTmp.retryWaitTime;
        this.src_ConnNm = kafkaProducerJob_InstTmp.src_ConnNm;
        this.tgt_ConnNm = kafkaProducerJob_InstTmp.tgt_ConnNm;
    }

    compare(kafkaProducerJob_InstTmp: KafkaProducerJob_Inst): string {
        let kafkaProducerJob_InstString: string =this.toString();
        let kafkaProducerJob_InstTmpString: string = kafkaProducerJob_InstTmp.toString();

        if (kafkaProducerJob_InstString != kafkaProducerJob_InstTmpString) {
            return kafkaProducerJob_InstString + ', ' + kafkaProducerJob_InstTmpString;
        }

        return '';
    }

    toString(): string {
        let str: string = "RestJob_Inst [dxFlow_Id=" + this.dxFlow_Id +
            ", kafkaproducer_inst_id=" + this.kafkaproducer_inst_id +
            ", nm=" + this.nm +
            ", description=" + this.description +
            ", ver=" + this.ver +
            ", valid_Cd=" + this.valid_Cd +
            ", disableFlg=" + this.disableFlg +
            ", updateDt=" + this.updateDt +
            ",retryEnabled ="+ this.retryEnabled +
            ",numOfRetryAttempts ="+this.numOfRetryAttempts +
            ",retryWaitTime =" +this.retryWaitTime+
            ",src_ConnNm ="+ this.src_ConnNm+
            ",tgt_ConnNm ="+ this.tgt_ConnNm;

            str += ']';
    
            return str;
        }
}